<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Manage Order</h5>
                </div>
                <div class="card-body">
                    <div class="custom-datatable">
                        <input type='text' class="filter-ngx form-control" placeholder='Search...'
                            (keyup)='updateFilter($event)' />
                        <ngx-datatable class="bootstrap" [rows]="order" [columnMode]="'force'" [headerHeight]="50"
                            [footerHeight]="50" [rowHeight]="'auto'" [limit]="5">
                            <ngx-datatable-column prop="orderId">
                                <ng-template ngx-datatable-cell-template let-row="row">
                                    <a [routerLink]="['/sales/orders', row.orderId]" class="text-primary">
                                        {{ row.orderId }}
                                      </a>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column prop="status">
                                <ng-template ngx-datatable-cell-template let-row="row">
                                    <ng-container *ngIf="statusOptions?.length">
                                        <select (change)="onStatusChange(row, +$event.target.value)">
                                          <option 
                                            *ngFor="let s of statusOptions" 
                                            [value]="s.idStatus" 
                                            [selected]="s.idStatus === row.statusId">
                                            {{ s.description }}
                                          </option>
                                        </select>
                                      </ng-container>
                                </ng-template>
                              </ngx-datatable-column>
                            <ngx-datatable-column name="orderDate"></ngx-datatable-column>
                            <ngx-datatable-column name="Customer">
                                <ng-template ngx-datatable-cell-template let-row="row">
                                    {{ row.customer?.firstName }} {{ row.customer?.lastName }}
                                  </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Email">
                                <ng-template ngx-datatable-cell-template let-row="row">
                                    {{ row.customer?.email }}
                                  </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Address">
                                <ng-template ngx-datatable-cell-template let-row="row">
                                    {{ row.customer?.address }} {{ row.customer?.city }} {{ row.customer?.country }}
                                  </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Total"></ngx-datatable-column>
                        </ngx-datatable>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 👇 VERY IMPORTANT -->
    <!-- Container-fluid Ends-->